export const ATTESTATION_FILE_SUB_TYPES = ['Kbis', 'Statut', 'PV d\'AG', 'CA', 'Textes réglementaires'];
export const DELEGATE_FILE_SUB_TYPES = ['Déclaration sur l\'honneur'];